import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";
import { ORDER_STATUS_MAP } from "../../../constants/orderStatus.config";

const OrderFormModal = ({ isOpen, onClose, onSave, order, language }) => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    address: "",
    area_id: "",
    order_status: 1,
    order_type: 1,
    discount: 0,
    notes: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (!order) return;

    setFormData({
      first_name: order.first_name || "",
      last_name: order.last_name || "",
      phone_number: order.phone_number || "",
      address: order.address || "",
      area_id: order.area_id || "",
      order_status: order.order_status || 1,
      order_type: order.order_type || 1,
      discount: order.discount || 0,
      notes: order.notes || "",
    });

    setErrors({});
  }, [order, isOpen]);

  const labels = {
    editTitle: { en: "Edit Order", ar: "تعديل الطلب" },
    firstName: { en: "First Name", ar: "الاسم الأول" },
    lastName: { en: "Last Name", ar: "اسم العائلة" },
    phone: { en: "Phone Number", ar: "رقم الهاتف" },
    address: { en: "Address", ar: "العنوان" },
    status: { en: "Order Status", ar: "حالة الطلب" },
    type: { en: "Order Type", ar: "نوع الطلب" },
    notes: { en: "Notes", ar: "ملاحظات" },
    discount: { en: "Discount", ar: "الخصم" },
    cancel: { en: "Cancel", ar: "إلغاء" },
    save: { en: "Save", ar: "حفظ" },
    required: { en: "This field is required", ar: "هذا الحقل مطلوب" },
    direct: { en: "Direct", ar: "مباشر" },
    indirect: { en: "Indirect", ar: "غير مباشر" },
  };

  const statusOptions = Object.entries(ORDER_STATUS_MAP).map(
    ([value, item]) => ({
      value: Number(value),
      label: item.label[language],
    })
  );

  const typeOptions = [
    { value: 1, label: labels.direct[language] },
    { value: 2, label: labels.indirect[language] },
  ];

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const validate = () => {
    const e = {};
    if (!formData.first_name) e.first_name = labels.required[language];
    if (!formData.last_name) e.last_name = labels.required[language];
    if (!formData.phone_number) e.phone_number = labels.required[language];
    if (!formData.address) e.address = labels.required[language];
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSave(formData);
  };

  if (!isOpen) return null;

  return (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4">
  <div className="bg-card w-full max-w-xl md:max-w-2xl lg:max-w-3xl rounded-xl border border-border shadow-lg overflow-y-auto max-h-[90vh]">
    {/* Header */}
    <div className="flex justify-between items-center px-6 py-4 border-b sticky top-0 bg-card z-10">
      <h2 className="text-xl font-semibold">{labels.editTitle[language]}</h2>
      <button onClick={onClose}>
        <Icon name="X" size={20} />
      </button>
    </div>

    {/* Form */}
    <form onSubmit={handleSubmit} className="p-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={labels.firstName[language]}
          value={formData.first_name}
          onChange={(e) => handleChange("first_name", e.target.value)}
          error={errors.first_name}
        />
        <Input
          label={labels.lastName[language]}
          value={formData.last_name}
          onChange={(e) => handleChange("last_name", e.target.value)}
          error={errors.last_name}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label={labels.phone[language]}
          value={formData.phone_number}
          onChange={(e) => handleChange("phone_number", e.target.value)}
          error={errors.phone_number}
        />
        <Input
          label={labels.address[language]}
          value={formData.address}
          onChange={(e) => handleChange("address", e.target.value)}
          error={errors.address}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Select
          label={labels.status[language]}
          options={statusOptions}
          value={formData.order_status}
          onChange={(v) => handleChange("order_status", v)}
        />
        <Select
          label={labels.type[language]}
          options={typeOptions}
          value={formData.order_type}
          onChange={(v) => handleChange("order_type", v)}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          type="number"
          label={labels.discount[language]}
          value={formData.discount}
          onChange={(e) => handleChange("discount", e.target.value)}
        />
        <div></div>
      </div>

      <textarea
        className="w-full border rounded-md p-2 resize-none"
        placeholder={labels.notes[language]}
        value={formData.notes}
        onChange={(e) => handleChange("notes", e.target.value)}
        rows={4}
      />

      <div className="flex gap-3 pt-4">
        <Button type="button" variant="outline" onClick={onClose}>
          {labels.cancel[language]}
        </Button>
        <Button type="submit">{labels.save[language]}</Button>
      </div>
    </form>
  </div>
</div>

  );
};

export default OrderFormModal;
